// extracted by mini-css-extract-plugin
export default {"wrap":"chatNavbar_wrap__nxaj1","userInfo":"chatNavbar_userInfo__idwNe"};